<template>
  <v-layout column>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs6>
        <app-reference
          v-model="entity.Country"
          :outline="true"
          class="mx-2 my-0"
          label="Страна отправления*"
          :rules="[v => !!v || '']"
          :height-field="44"
          resource="countries"
          component-name="Country"
          :error="checkMissingElement(entity.Country, true)"
          :scroll-value="scrollValue"
          :disabled="disabled"
          @input="clearSender"
        />
      </v-flex>
      <v-flex xs6>
        <app-reference
          ref="sender-addresses"
          v-model="entity.SenderAddress"
          :outline="true"
          class="mx-2 my-0"
          label="Адрес погрузки*"
          :rules="[v => !!v || '']"
          resource="addresses"
          parent-filter="countryId"
          :parent-id="entity.Country ? entity.Country.id : 0"
          component-name="Address"
          :without-parent-lock="true"
          :height-field="44"
          :error="checkMissingElement(entity.SenderAddress, true)"
          :scroll-value="scrollValue"
          :disabled="disabled"
          @input="addressChanged()"
        />
      </v-flex>
    </v-layout>

    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs12>
        <app-tiny-reference
          ref="client-alias"
          v-model="entity.ClientAlias"
          :outline="true"
          class="mx-2 my-0"
          label="Клиент по документам*"
          resource="clients/aliases"
          parent-filter="clientId"
          :parent-id="entity.Client ? entity.Client.id : 0"
          :without-length-lock="true"
          :height-field="44"
          :scroll-value="scrollValue"
          :rules="[v => !!v || '']"
          :error="checkMissingElement(entity.ClientAlias, true)"
          @input="handleEntityChange"
        >
          <template v-slot:append-content="slotProps">
            <v-layout align-end>
              <v-text-field
                v-model="newClientAlias"
                outline
                class="px-1 pt-0 mt-0 text-field-size"
                placeholder="Добавить название"
                hide-details
                height="44"
              />
              <v-divider horisontal />
              <v-spacer />
              <v-btn
                small
                :disabled="newClientAlias.length < 1"
                class="ma-0 ml-0 mr-1 plus-button"
                @click="saveNewClientAlias(slotProps.items)"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
          </template>
        </app-tiny-reference>
      </v-flex>
    </v-layout>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs12>
        <v-textarea
          slot="activator"
          v-model="entity.LoadingNumber"
          outline
          class="mx-2 my-0"
          hide-details
          rows="1"
          auto-grow
          label="Референс погрузки"
          @input="handleEntityChange"
        />
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-text-field
        v-model="entity.LoadingPlaceTimetable"
        outline
        class="mx-2 my-0"
        label="Время работы места погрузки"
        hide-details
        height="44"
      />
    </v-flex>
    <v-flex xs12>
      <LoadingContacts
        :value="entity.ContactsLoading"
        :scroll-value="scrollValue"
        :entity-id="entity.Id"
        sender-type="ADDRESS"
        class="my-2"
        @change="contactsLoadingChanged"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import LoadingContacts from "./LoadingContacts.vue";
import { updateNewClientAlias } from "../../../../backend/newShippingApi.js";
import { getAddress } from "../../../../backend/shippingsApi.js";

export default {
  components: { LoadingContacts },
  props: [
    "entity",
    "fieldStyle",
    "isHighlightLabel",
    "scrollValue",
    "changedSenderType",
    "disabled",
    "changeInfo",
  ],
  data() {
    return {
      newClientAlias: "",
    };
  },
  watch: {
    changeInfo: {
      handler(val) {
        if (val && !!this.entity.LoadingNumber) {
          this.entity.LoadingNumber = this.entity.LoadingNumber.replace(/\n/g, "; ");
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.entity.Id && !this.changedSenderType) {
      return;
    }
    this.clearSender();
  },
  methods: {
    handleEntityChange() {
      this.$emit("handleEntityChange");
    },
    clearSender() {
      this.entity.LoadingAddress = null;
      this.entity.SenderAddress = null;
      this.entity.ContactsLoading = [];
      this.entity.LoadingPlaceTimetable = "";
    },
    async addressChanged() {
      this.entity.LoadingAddress = null;
      if (!this.entity.SenderAddress) {
        return;
      }

      this.$set(this.entity, "LoadingAddress", {
        id: this.entity.SenderAddress.id,
        title: this.entity.SenderAddress.title,
      });

      const response = await getAddress(this.entity.SenderAddress.id);
      this.$set(this.entity, "Country", {
        id: response.Country.Id,
        title: response.Country.Title,
      });
    },
    async saveNewClientAlias(items) {
      await updateNewClientAlias(this.entity.Client.id, this.newClientAlias);
      this.entity.ClientAlias = this.newClientAlias;
      items.push({ value: this.newClientAlias, text: this.newClientAlias });
      this.$refs["client-alias"].$children[0].blur();
      this.newClientAlias = "";
    },
    getMask(controlType) {
      switch (controlType) {
        case "phone":
          return "+##(###)###-##-##";
        case "number":
          return "##########";
        default:
          return "";
      }
    },
    checkMissingElement(value, required) {
      if (!this.isHighlightLabel) {
        return;
      }
      if (!value && !required) {
        return "label-color";
      }
      if (!value && required) {
        return true;
      }
    },
    contactsLoadingChanged(contactDetails) {
      this.entity.ContactsLoading = [];
      this.$set(this.entity, "ContactsLoading", contactDetails);
      this.handleEntityChange();
    },
  },
};
</script>
